import { Locations } from './GraphQL';

// Live/prod FRIDGE locations. Reuses the 'locationsLoaded' cache /locations/all
// writes; falls back to a live query when cold. `Locations()` filters type FRIDGE.

/**
 * Both paths must return the same set in the same order, or a caller's data depends
 * on whether another page warmed the cache first (PortfolioHealth reads this).
 */
function normalize(locations) {
  return locations
    .filter((location) => location.prod === 1)
    .sort((a, b) => String(a.id).localeCompare(String(b.id)));
}

// Only trust a cache carrying these — one written before a field was added to
// the `Locations()` selection has it undefined everywhere, silently breaking
// whatever filters on it (this bit `ip`, then `onlineDate`). Add a field here
// when you add it to that query, but only if nearly every location has one:
// a mostly-null field would reject even a fresh cache.
const CACHE_PROBE_FIELDS = ['ip', 'onlineDate'];

function readCache() {
  // A malformed cache would throw past the live fallback and strand
  // PortfolioHealth's loading state. Unreadable cache = no cache.
  try {
    return JSON.parse(localStorage.getItem('locationsLoaded'));
  } catch (e) {
    console.error('Ignoring malformed locationsLoaded cache', e);
    return null;
  }
}

export default async function fetchFridgeLocations() {
  const cached = readCache();
  if (
    cached?.locations?.length &&
    CACHE_PROBE_FIELDS.every((field) =>
      cached.locations.some((location) => typeof location[field] === 'string'),
    )
  ) {
    return normalize(cached.locations);
  }
  return normalize(await Locations());
}
